module.exports = __webpack_public_path__ + "img/201609-2.979c5c41.jpg";